"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./defineProperty-b53f90b9.js"),
  t = require("./extends-fa579b0f.js"),
  a = require("react"),
  n = require("prop-types"),
  r = require("./grid-965d799c.js"),
  i = require("./link-8b1ebef7.js"),
  l = require("./sectionContainer-2a921e1c.js"),
  d = require("./typography-fb2881fe.js"),
  o = require("./foundations/Icon/icons/utility/CaratRight.js"),
  u = require("./taggedTemplateLiteral-97b463ad.js"),
  c = require("styled-components"),
  m = require("polished/lib/helpers/rem"),
  p = require("./picture-b1ad7caa.js");
function f(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var g,
  s,
  T,
  y,
  b,
  h,
  x,
  k,
  L,
  j,
  O,
  v,
  P,
  _,
  q,
  E,
  C,
  w = f(a),
  U = f(n),
  D = f(c),
  A = f(m),
  I = D["default"](r.Col)(g || (g = u._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = 0,
      n = t.mediumUp(),
      r = t.largeUp();
    return t.xlargeUp() ? a = A["default"](65) : r ? a = A["default"](40) : n && (a = A["default"](30)), c.css(s || (s = u._taggedTemplateLiteral(["\n      text-align: left;\n      padding-right: ", ";\n    "])), a);
  }),
  S = D["default"](r.Col)(T || (T = u._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme;
    return c.css(y || (y = u._taggedTemplateLiteral(["\n    ", ";\n  "])), t.mediumDown() && "display: none;");
  }),
  B = D["default"].div(b || (b = u._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.buttonText,
      n = e.LinkText,
      r = A["default"](32);
    return a || n || (r = 0), c.css(h || (h = u._taggedTemplateLiteral(["\n      display: ", ";\n      padding-bottom: ", ";\n    "])), t.mediumUp() ? "none" : "block", r);
  }),
  R = D["default"].div(x || (x = u._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme;
    return c.css(k || (k = u._taggedTemplateLiteral(["\n    background-color: ", ";\n    padding: ", ";\n    margin: 0 ", ";\n  "])), t.colors.background.lightTheme.lightB, t.mediumUp() ? A["default"](48) : A["default"](32), t.mediumUp() ? A["default"](10) : 0);
  }),
  H = D["default"](i.LinkComponent)(L || (L = u._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = t.mediumUp() ? 0 : "auto";
    return c.css(j || (j = u._taggedTemplateLiteral(["\n      margin-bottom: ", ";\n      margin-left: ", ";\n      margin-right: ", ";\n      ", "\n    "])), t.mediumUp() ? A["default"](24) : A["default"](14), a, a, !t.mediumUp() && "display: block;");
  }),
  V = D["default"](i.LinkComponent)(O || (O = u._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme;
    return c.css(v || (v = u._taggedTemplateLiteral(["\n    display: block;\n    padding-bottom: 0;\n    ", ";\n    @media print {\n      display: none;\n    }\n  "])), !t.mediumUp() && "text-align: center;");
  }),
  z = D["default"](p.PictureComponent)(P || (P = u._taggedTemplateLiteral(["\n  padding-top: 0;\n  padding-bottom: ", ";\n  width: 60%;\n  max-width: ", ";\n  margin: 0 auto;\n"])), A["default"](16), A["default"](150)),
  N = D["default"](d.TypographyComponent)(_ || (_ = u._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme;
    return c.css(q || (q = u._taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: 300;\n    text-align: center;\n    color: ", ";\n    overflow: hidden;\n    padding-bottom: ", ";\n    ::after {\n      content: '';\n      display: block;\n      width: ", ";\n      height: ", ";\n      background-color: ", ";\n      margin: ", " auto 0;\n    }\n    @media print {\n      ::after {\n        display: none;\n      }\n    }\n  "])), A["default"](50), A["default"](50), t.colors.blue.blue, t.mediumUp() ? A["default"](18) : A["default"](20), A["default"](48), A["default"](3), t.colors.gold.gold, A["default"](18));
  }),
  M = D["default"](d.TypographyComponent)(E || (E = u._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme;
    return c.css(C || (C = u._taggedTemplateLiteral(["\n    text-align: ", ";\n  "])), t.mediumUp() ? "left" : "center");
  });
function W(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), a.push.apply(a, n);
  }
  return a;
}
function F(t) {
  for (var a = 1; a < arguments.length; a++) {
    var n = null != arguments[a] ? arguments[a] : {};
    a % 2 ? W(Object(n), !0).forEach(function (a) {
      e._defineProperty(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : W(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
var G = function G(e) {
  var a = e.backgroundVariant,
    n = e.cardDescriptionText,
    i = e.cardDescriptionTextAriaLabel,
    u = e.cardHeadingText,
    c = e.cardHeadingTextAriaLabel,
    m = e.cardImage,
    p = e.cardImageAltText,
    f = e.ctaPrimary,
    g = e.ctaSecondary,
    s = e.descriptionText,
    T = e.disableBottomPadding,
    y = e.headingText,
    b = e.sectionId,
    h = e.themeType,
    x = function x() {
      return w["default"].createElement(R, null, m && w["default"].createElement(z, {
        lazyLoad: !1,
        src: m,
        altText: p,
        fullWidth: !0
      }), u && w["default"].createElement(N, {
        component: "h3",
        ariaLabel: c || ""
      }, u), n && w["default"].createElement(d.TypographyComponent, {
        component: "p",
        align: "center",
        ariaLabel: i || "",
        disableBottomPadding: !0
      }, n));
    };
  return w["default"].createElement(l.SectionContainerComponent, {
    id: "section-".concat(b),
    backgroundVariant: a,
    themeType: h,
    moduleName: "stat-module",
    moduleVariation: "A",
    disableBottomPadding: T
  }, w["default"].createElement(r.Row, {
    align: "left"
  }, w["default"].createElement(I, {
    xsmall: 12,
    medium: 6,
    large: 8
  }, w["default"].createElement(M, {
    component: "h2",
    themeType: h
  }, y), w["default"].createElement(d.TypographyComponent, {
    themeType: h,
    nextElement: "button"
  }, s), w["default"].createElement(B, {
    buttonText: f.linkText,
    linkText: g.linkText
  }, x()), f && f.linkText && w["default"].createElement(H, t._extends({}, f, {
    id: "".concat(b, "-cta-primary"),
    themeType: h,
    variant: "buttonLinkPrimary"
  }), f.linkText, " "), g && g.linkText && w["default"].createElement(V, t._extends({}, g, {
    id: "".concat(b, "-cta-secondary"),
    endAdornment: o,
    endAdornmentStylesReset: !0,
    themeType: h,
    variant: "primaryDeemphasize"
  }), g.linkText, " ")), w["default"].createElement(S, {
    medium: 6,
    large: 4
  }, x())));
};
G.propTypes = {
  backgroundVariant: U["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  cardDescriptionText: U["default"].any,
  cardDescriptionTextAriaLabel: U["default"].any,
  cardHeadingText: U["default"].oneOfType([U["default"].string, U["default"].object]),
  cardHeadingTextAriaLabel: U["default"].any,
  cardImage: U["default"].any,
  cardImageAltText: U["default"].any,
  className: U["default"].string,
  ctaPrimary: U["default"].shape(F({
    linkId: U["default"].string,
    linkText: U["default"].oneOfType([U["default"].string, U["default"].object])
  }, i.linkPropTypes)),
  ctaSecondary: U["default"].shape(F({
    linkId: U["default"].string,
    linkText: U["default"].oneOfType([U["default"].string, U["default"].object])
  }, i.linkPropTypes)),
  descriptionText: U["default"].any.isRequired,
  disableBottomPadding: U["default"].bool,
  headingText: U["default"].any.isRequired,
  sectionId: U["default"].string.isRequired,
  themeType: U["default"].oneOf(["lightTheme", "darkTheme", "nmx-pcg"])
}, exports.StatModuleComponent = G;